import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  width: 3.61875rem; //50.85px;
  z-index: 5;
`;

export const Boxloader = styled.div`
  width: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  height: 20rem;
  margin: 0 auto 10rem auto;

  h1 {
    color: #42464c;
    font-family: Sora;
    margin: 0 0 0 1rem;
  }
`;
